// Phase 5 — React Query hook for the map screen.
//
// The endpoint returns the full station catalog in one shot; we
// cache for 30 s (same staleTime convention as
// `useAvailableConfigs` from Phase 6.6) so prying the bottom sheet
// open and closed doesn't re-fetch. The catalog rarely changes —
// only when the IGS registry importer touches it — so 30 s is
// safe and keeps the UI responsive between navigation events.

import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';
import type { MapStationsResponse } from '../api/types';

export function useMapStations() {
  return useQuery<MapStationsResponse>({
    queryKey: ['map', 'stations'],
    queryFn: () => api.getMapStations(),
    staleTime: 30_000,
  });
}
